/* eslint-disable  @typescript-eslint/no-explicit-any */
import type {FacetResponse} from '../../../../models/cose-api/response/facet-options.model';
import type {FilterNode} from '../filter-node';
import {cloneObjectWithNoReference} from '../../../../utils/helpers/clone-object-with-no-reference';
import type {FacetChildUiModel, FacetTreeUiModel} from '../../../../models/ui/facets/facet-tree-ui.model';
import {FacetsV2Service} from '../../../../utils/services/facets/facets-v2.service';
import {refactorTreeByDividerMobileFacets} from './refactor-tree-by-divider-mobile-facets';
import {refactorTreeByDividerFacets} from './refactor-tree-by-divider-facets';
import type {FacetsShowChildrenType} from '../../../strategies/types/facets-config-strategy-data.type';
import {FilterChangeContext} from '../models/filter-change-context.enum';
import {FILTERS_ID_SEPARATOR} from '../../../../constants/filterConstants';

export function facetsDataCreator(
  facets: FacetResponse[],
  dividerFacets: string[],
  dividerMobileFacets: string[],
  facetsChipsState: FilterNode[],
  facetsState: any[],
  facetLocalChipsState: FilterNode[] = [],
  totalHits?: number | undefined,
  showChilds: FacetsShowChildrenType = 'allways',
  flatFacets = false,
  context: FilterChangeContext = FilterChangeContext.all
) {
    let filteredMobileFacets = cloneObjectWithNoReference(facets) as FacetTreeUiModel[];
    let filteredFacets = cloneObjectWithNoReference(facets) as FacetTreeUiModel[];
    let outerFacets = [];
    let outerMobileFacets = [];
    let flatFacetsList = [];

    if(dividerMobileFacets && dividerMobileFacets?.length > 0 && !flatFacets) {
      const refactoredData: {outerFacets: FacetTreeUiModel[], filteredFacets: FacetTreeUiModel[]}
      = refactorTreeByDividerMobileFacets(filteredMobileFacets, dividerMobileFacets);
      outerMobileFacets = refactoredData.outerFacets;
      filteredMobileFacets = refactoredData.filteredFacets;
    }

    if(dividerFacets && dividerFacets?.length > 0) {
      const refactoredData: {outerFacets: FacetChildUiModel[], filteredFacets: FacetTreeUiModel[]}
      = refactorTreeByDividerFacets(filteredFacets, dividerFacets);
      outerFacets = refactoredData.outerFacets;
      filteredFacets = refactoredData.filteredFacets;
    }

    let onlyLastChilds: FacetTreeUiModel[] | FacetChildUiModel[] = [];

    if(showChilds === 'onlyLastChilds') {
      onlyLastChilds = FacetsV2Service.getLastChildsFacets(FacetsV2Service.setUnique(cloneObjectWithNoReference(facets)) as FacetTreeUiModel[], []);
    }

    if(flatFacets) {
      flatFacetsList = FacetsV2Service.flatFactesResponseTree(cloneObjectWithNoReference(FacetsV2Service.setUnique(facets)));

      if(context !== FilterChangeContext.mobile && context !== FilterChangeContext.resetAll) {
        const localChipsStateFromResponse: FacetTreeUiModel[] | FacetChildUiModel[] = FacetsV2Service.makeLocalChipsStateForSingleSelectionFromResponse(flatFacetsList);

        localChipsStateFromResponse.forEach((fl) => {
            const parentUniqueString = getParentUniqueString(fl.uniqueId);
            facetLocalChipsState = facetLocalChipsState.filter(fll => getParentUniqueString(fll.uniqueId) !== parentUniqueString);
        });

        localChipsStateFromResponse.forEach((fl) => {
            facetLocalChipsState.push(fl);
        });

        facetLocalChipsState = facetLocalChipsState.filter(f=>!!f);;
      }

      if(context === FilterChangeContext.resetAll) {
        facetLocalChipsState = [];
        flatFacetsList.filter(fll=>fll.expression === 'SINGLE').forEach((fc) => {
            fc.children.forEach((fl) => {
                if(fl.selected) {
                  facetLocalChipsState.push(fl);
                }
            });
        });
      }
    }


    return {
      totalHits,
      facets: FacetsV2Service.setUnique(facets),
      filteredFacets: FacetsV2Service.setUnique(filteredFacets),
      outerFacets: FacetsV2Service.setUnique(outerFacets),
      filteredMobileFacets: FacetsV2Service.setUnique(filteredMobileFacets),
      outerMobileFacets: FacetsV2Service.setUnique(outerMobileFacets),
      onlyLastChilds: onlyLastChilds,
      notLastUniqueIds: FacetsV2Service.getNotLastChildsValuesIdsFromUnique2(onlyLastChilds) || {},
      facetLocalChipsState,
      flatFacetsList,
      facetsChipsState,
      facetsState
    };
}

function getParentUniqueString(uniqueId: string): string {
    return uniqueId.split(FILTERS_ID_SEPARATOR).slice(0, -1).join(FILTERS_ID_SEPARATOR);
}
